import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, FormGroup } from 'react-bootstrap';
import styles from './postboost.module.scss';
import PostBoostOption from './PostBoostOption';
import PostBoostBenefits from './PostBoostBenefits';
import { Link } from 'react-bootstrap/lib/Navbar';
import { trackEvent } from 'helpers/Analytics';

const iconPropeller = require('./propeller.png').default;
const iconJet = require('./jet.png').default;
const iconRocket = require('./rocket.png').default;

const PostBoost = ({ nextFunction }) => {
  const [optionsVisible, setOptionsVisible] = useState(false);
  const [thankYouVisible, setThankYouVisible] = useState(false);

  useEffect(() => trackEvent('post-viewed-boost-summary'), []);

  return (
    <form className={styles.form} id="post-brief-boost">
      {!thankYouVisible && (
        <p className="fs-30 lato-bold text-center">
          Do you want to BOOST your job?
        </p>
      )}

      {!thankYouVisible && <PostBoostBenefits />}

      {!thankYouVisible && (
        <FormGroup className={styles.boostFormGroup}>
          {!optionsVisible && (
            <Button
              bsStyle="primary"
              className={styles.marginCentered}
              onClick={() => {
                setOptionsVisible(true);
                setTimeout(
                  () =>
                    window.scrollTo({
                      top: 300,
                      behavior: 'smooth',
                    }),
                  100
                );
                trackEvent('post-viewed-boost-pricing');
              }}
              name="post-brief-boost-see-options"
            >
              I want to Boost my job!
            </Button>
          )}

          {optionsVisible && (
            <div className={styles.boostOptions}>
              <PostBoostOption
                buttonLabel={'Boost'}
                title={'Propeller'}
                duration={'7 day boost'}
                oldPrice={39.99}
                price={19.99}
                icon={iconPropeller}
                clickFunction={() => {
                  setThankYouVisible(true);
                  trackEvent('post-clicked-boost', {
                    option: 'propeller',
                    duration: '7 day boost',
                    price: 19.99,
                  });
                }}
              />
              <PostBoostOption
                buttonLabel={'Jet Boost!'}
                title={'Jet'}
                duration={'14 day boost'}
                oldPrice={49.99}
                price={29.99}
                icon={iconJet}
                clickFunction={() => {
                  setThankYouVisible(true);
                  trackEvent('post-clicked-boost', {
                    option: 'jet',
                    duration: '14 day boost',
                    price: 29.99,
                  });
                }}
              />
              <PostBoostOption
                buttonLabel={'ROCKET BOOST!'}
                title={'Rocket'}
                duration={'30 day boost'}
                oldPrice={119.99}
                price={59.99}
                icon={iconRocket}
                clickFunction={() => {
                  setThankYouVisible(true);
                  trackEvent('post-clicked-boost', {
                    option: 'rocket',
                    duration: '30 day boost',
                    price: 59.99,
                  });
                }}
              />
            </div>
          )}

          {optionsVisible && (
            <p className={styles.boostAnnual}>
              Boost your visibility! Our dedicated sales team offers custom
              packages for high-volume job promotion,{' '}
              <Link to="/enterprise">contact us here</Link> to learn more.
            </p>
          )}
        </FormGroup>
      )}

      {!thankYouVisible && optionsVisible && (
        <div className={styles.textCentered}>
          <Button
            bsStyle="secondary"
            name="post-brief-boost-skip"
            onClick={() => {
              trackEvent('post-clicked-boost-skip');
              return nextFunction();
            }}
          >
            {"I don't want to Boost"}
          </Button>
        </div>
      )}
      {thankYouVisible && (
        <div className={styles.thankYouBox}>
          <div className="fs-30 lato-bold">Hello!</div>
          <p className="fs-16">
            {
              "You've caught us before we are ready. We're thrilled to know that you're interested in boosting your job post. We'll be in touch when this feature is ready for you to use."
            }
          </p>
          <p className="fs-16">
            {
              "Please click the 'Next' button below right to finish posting your job."
            }
          </p>
        </div>
      )}
    </form>
  );
};

PostBoost.propTypes = {
  nextFunction: PropTypes.func,
};

export default PostBoost;
